var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-page container"},[_c('n-card',[_c('n-table',{attrs:{"data":_vm.data,"columns":_vm.columns,"loading":_vm.$var('load')},scopedSlots:_vm._u([{key:"avatar",fn:function(ref){
var item = ref.item;
return [_c('n-image',{attrs:{"centered":"","src":item.image}})]}},{key:"tools",fn:function(ref){
var item = ref.item;
return [_c('n-button',{attrs:{"icon":"eye","flat":"","round":""},on:{"click":function($event){return _vm.$router.push({name: 'images.edit', params: { id: item.id, }})}}})]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }